
export const auto_model = {
  "covers": [],
  "region": {},
  "register_region": {
    "name": "",
    "language": "",
    "region": "",
    "region_code": "",
    "country": "",
    "country_code": "",
    "province": "",
    "province_code": "",
    "city": "",
    "address": "海南海口",
    "town": "",
    "district": "",
    "full_address": "",
    "latitude": "",
    "longitude": ""
  },
  "license_plate": "琼AF3F60",
  "vin_no": "LSJA36U65MN095109",
  "meter_mileage": "74372",
  "displacement": "1.5",
  "displacement_unit": "T",
  "model": "名爵MG5",
  "gearbox_type": "AUTO",
  "gearbox_no": "",
  "gearbox_model": "",
  "first_boarding_date": "",
  "vehicle_color": "灰色",
  "vehicle_use": "NON_OPERATION",
  "nature_of_use": "PERSONAL",
  "maintenance_status": "",
  "annual_inspection_expiration": "",
  "strong_insurance_expiry": "",
  "vehicle_source": "DOMESTIC",
  "amount_of_protection_number": "",
  "amount_of_protection_zh": "",
  "identifier": "f4450cbc-765a-4ef1-bc20-e7bfbb090a91",
  "create_at": "2025-08-09T18:29:38.724107+08:00",
  "remark": "",
  "engine_no": ""
}
export const customer_model = {
  "region": "",
  "date_of_birth": "2025-08-09T18:29:38.726359+08:00",
  "email": "",
  "mobile": "",
  "username": "",
  "name": "",
  "sex": "unknown",
  "thumb": "",
  "age": 0,
  "nickname": "",
  "userid": "304d967d-5b46-4b44-a099-f08ba6c1b3ae",
  "idcard_no": "",
  "identifier": "83ef4fa3-8de4-4d09-b7be-4298c1420b0d",
  "create_at": "2025-08-09T18:29:38.726393+08:00",
  "user": ""
}
export const inspector_model = {
  "id": 97,
  "appraisal_certificates": [
    {
      "image_url": "https://chezhibao.ltd/media/Inspector/AppraisalCertificate/images/tmp_i1muhad.jpg",
      "image": "/media/Inspector/AppraisalCertificate/images/tmp_i1muhad.jpg",
      "url": "",
      "download_url": "",
      "name": "检测师证书 - 检测师名字=林思清-name=/xy_web_service/tmp/tmp_i1muhad.jpg",
      "width": 0,
      "height": 0,
      "create_at": "2022-06-18T10:11:54.340672+08:00",
      "update_at": "2022-06-18T10:11:54.340709+08:00",
      "description": "",
      "path": "",
      "cdn_domain": "",
      "identifier": "b63df888-f398-4c19-9582-e49e538d25b3",
      "region": {}
    }
  ],
  "sign": {
    "image_url": "https://chezhibao.ltd/media/Inspector/Sign/images/sign.png",
    "image": "/media/Inspector/Sign/images/sign.png",
    "url": "",
    "download_url": "",
    "name": "检测师签名-检测师名字=林思清",
    "width": 0,
    "height": 0,
    "create_at": "2022-05-29T21:30:20.748454+08:00",
    "update_at": "2022-05-29T21:30:20.748486+08:00",
    "description": "",
    "path": "",
    "cdn_domain": "",
    "identifier": "a79a92ff-a2a1-4585-ad26-07357f94fc5f",
    "region": {}
  },
  "thumb_url": "https://chezhibao.ltd/media/SiteUser/SiteUser/user/thumbnails/tmpcgbtoqy5.jpg",
  "region": "",
  "date_of_birth": "2025-08-15T16:56:11.586358+08:00",
  "email": "",
  "mobile": "",
  "username": "czb0003",
  "name": "林思清",
  "sex": "unknown",
  "thumb": "/media/SiteUser/SiteUser/user/thumbnails/tmpcgbtoqy5.jpg",
  "age": 0,
  "nickname": "林思清",
  "userid": "67408725-56c8-4d63-b39f-7bf18feea328",
  "idcard_no": "",
  "self_introduction": "",
  "level": "Advanced",
  "identifier": "42309e06-da5a-4e0d-ad8c-d7326468fdaa",
  "create_at": "2025-08-15T16:56:11.586378+08:00"
}
export const order_model_data = {
  "remark": "None",
  "maintenance_recommendations": "该车局部外观及前后保险杠有喷漆，前后保险杠有拆装，左后翼子板轮窝眉位置有刮碰钣金腻子喷漆；前防撞梁及龙门架有拆装更换，前两边大灯总成有更换，变速箱阀体有拆装更换；无泡水，无火烧。",
  "identifier": "20bc416a-9548-4824-950c-d7768f7739ae",
  "special_desc": "None",
  "test_result": "",
  "detected": true,
  "extra_group_enable": false,
  "detected_at": "2025-08-09 10:32:11.122817+00:00",
  "create_at": "2025-08-22 05:30:03.576648+00:00",
  "update_at": "2025-08-22 05:30:03.576651+00:00",
  "auto_id": "f4450cbc-765a-4ef1-bc20-e7bfbb090a91",
  "customer_id": "83ef4fa3-8de4-4d09-b7be-4298c1420b0d",
  "menu_id": "1cd9bd64-584e-4dd0-9e15-a49496ac5942",
  "menu_mode": "BASE",
  "group_objects": [
    "05026cb4-1400-4840-b680-3ad5e73727b8",
    "75557df5-d5c4-495f-9cc5-38588b75c328",
    "b29ec93e-53cc-4c8f-8181-e2df1114c0da",
    "e98948f7-9e99-4377-9649-cfe81a667c64",
    "7ae76586-175a-466c-a0c7-26e2fc1ce887",
    "564d2e1e-abf4-44bf-b5df-b9385787a13a"
  ],
  "inspector_id": "42309e06-da5a-4e0d-ad8c-d7326468fdaa"
}

export const order_info_model = {
  "identifier": "32a9c724-9905-47b4-b393-8866d1d3fd11",
  "covers": [
    "https://chezhibao.ltd/media/Resource/Image/images/tmpgbwkvnwr.png",
    "https://chezhibao.ltd/media/Resource/Image/images/tmp94kp815p.png",
    "https://chezhibao.ltd/media/Resource/Image/images/tmpbi4dmns1.png",
    "https://chezhibao.ltd/media/Resource/Image/images/tmph4bbxhsq.png",
    "https://chezhibao.ltd/media/Resource/Image/images/tmp0k9o7ft8.png",
    "https://chezhibao.ltd/media/Resource/Image/images/tmpmwoa2cq9.png"
  ],
  "export_groups": [
    {
      "group_object_id": "05026cb4-1400-4840-b680-3ad5e73727b8",
      "group_object_group_id": "bde34bc8-6aac-4d8b-9993-22e8f6c1c31b",
      "group_name": "漆面检测",
      "group_short_label": "漆面",
      "cover_mode": "Plate",
      "success_count": 8,
      "warning_count": 11,
      "report_label": "覆盖件及漆面检测",
      "is_active": true,
      "report_config": {
        "identifier": "91bf348c-8094-408e-9c85-e0e9af65f203",
        "report_print_index": 9999,
        "show_print_report_icon": true,
        "show_print_report_table": true,
        "show_in_print_report": true,
        "page_break": true,
        "head_page_break": true,
        "test_result_min_height": 270,
        "page_bottom": "0"
      },
      "cover_url": "https://chezhibao.ltd/media/xy_django_app_resource/images/car_roof_red_jkEYJnJ.png",
      "test_result": null,
      "detected": true,
      "items": [
        {
          "success_count": 0,
          "warning_count": 2,
          "identifier": "a204d414-1524-49bb-8ca3-40c5ac44799c",
          "group_item_name": "前保险杠",
          "show_report_index": false,
          "report_index": 9999,
          "show_report_ok_name": false,
          "report_ok_name": "",
          "show_report_error_name": false,
          "report_error_name": "",
          "choice_mode": "MULTIPLE",
          "warning_name_list": [
            "喷漆",
            "拆装"
          ],
          "images": []
        },
        {
          "success_count": 0,
          "warning_count": 0,
          "identifier": "1a159a93-f82f-4101-91e4-91f17bcd0d9a",
          "group_item_name": "前保险杠_图片",
          "show_report_index": false,
          "report_index": 9999,
          "show_report_ok_name": false,
          "report_ok_name": "",
          "show_report_error_name": false,
          "report_error_name": "",
          "choice_mode": "DEFAULT",
          "warning_name_list": [],
          "images": []
        },
        {
          "success_count": 0,
          "warning_count": 3,
          "identifier": "07382163-1ae0-43a8-b162-9728c11ad3d8",
          "group_item_name": "左前翼子板",
          "show_report_index": false,
          "report_index": 9999,
          "show_report_ok_name": false,
          "report_ok_name": "",
          "show_report_error_name": false,
          "report_error_name": "",
          "choice_mode": "MULTIPLE",
          "warning_name_list": [
            "钣金",
            "喷漆",
            "拆装"
          ],
          "images": []
        },
        {
          "success_count": 0,
          "warning_count": 0,
          "identifier": "b58e8479-da84-4dbf-8da3-31140abaad70",
          "group_item_name": "左前翼子板_图片",
          "show_report_index": false,
          "report_index": 9999,
          "show_report_ok_name": false,
          "report_ok_name": "",
          "show_report_error_name": false,
          "report_error_name": "",
          "choice_mode": "DEFAULT",
          "warning_name_list": [],
          "images": []
        },
        {
          "success_count": 0,
          "warning_count": 1,
          "identifier": "05ed96b7-69dc-4965-91d7-45d38d25ca73",
          "group_item_name": "左A柱",
          "show_report_index": false,
          "report_index": 9999,
          "show_report_ok_name": false,
          "report_ok_name": "",
          "show_report_error_name": false,
          "report_error_name": "",
          "choice_mode": "MULTIPLE",
          "warning_name_list": [
            "喷漆"
          ],
          "images": []
        },
        {
          "success_count": 0,
          "warning_count": 0,
          "identifier": "b3a07859-4691-4e27-8966-f9ad283852e6",
          "group_item_name": "左A柱_图片",
          "show_report_index": false,
          "report_index": 9999,
          "show_report_ok_name": false,
          "report_ok_name": "",
          "show_report_error_name": false,
          "report_error_name": "",
          "choice_mode": "DEFAULT",
          "warning_name_list": [],
          "images": []
        },
        {
          "success_count": 0,
          "warning_count": 2,
          "identifier": "abc8e95b-c755-44c8-a027-f3c674ba0d95",
          "group_item_name": "左前门",
          "show_report_index": false,
          "report_index": 9999,
          "show_report_ok_name": false,
          "report_ok_name": "",
          "show_report_error_name": false,
          "report_error_name": "",
          "choice_mode": "MULTIPLE",
          "warning_name_list": [
            "钣金",
            "喷漆"
          ],
          "images": []
        },
        {
          "success_count": 0,
          "warning_count": 0,
          "identifier": "4cc0b469-0649-45c5-a12d-ccc443e5fab0",
          "group_item_name": "左前门_图片",
          "show_report_index": false,
          "report_index": 9999,
          "show_report_ok_name": false,
          "report_ok_name": "",
          "show_report_error_name": false,
          "report_error_name": "",
          "choice_mode": "DEFAULT",
          "warning_name_list": [],
          "images": []
        },
        {
          "success_count": 1,
          "warning_count": 0,
          "identifier": "22181448-3c53-4943-8045-607fab983cbd",
          "group_item_name": "左B柱",
          "show_report_index": false,
          "report_index": 9999,
          "show_report_ok_name": false,
          "report_ok_name": "",
          "show_report_error_name": false,
          "report_error_name": "",
          "choice_mode": "MULTIPLE",
          "warning_name_list": [],
          "images": []
        },
        {
          "success_count": 0,
          "warning_count": 0,
          "identifier": "ab8c7685-c27e-477a-abdf-c5648e0c9779",
          "group_item_name": "左B柱_图片",
          "show_report_index": false,
          "report_index": 9999,
          "show_report_ok_name": false,
          "report_ok_name": "",
          "show_report_error_name": false,
          "report_error_name": "",
          "choice_mode": "DEFAULT",
          "warning_name_list": [],
          "images": []
        },
        {
          "success_count": 0,
          "warning_count": 2,
          "identifier": "5000612d-9b8a-4364-8c56-a1ad7ead5670",
          "group_item_name": "左后门",
          "show_report_index": false,
          "report_index": 9999,
          "show_report_ok_name": false,
          "report_ok_name": "",
          "show_report_error_name": false,
          "report_error_name": "",
          "choice_mode": "MULTIPLE",
          "warning_name_list": [
            "喷漆",
            "拆装"
          ],
          "images": []
        },
        {
          "success_count": 0,
          "warning_count": 0,
          "identifier": "d006cee6-d75a-4feb-9060-5551b9aed178",
          "group_item_name": "左后门_图片",
          "show_report_index": false,
          "report_index": 9999,
          "show_report_ok_name": false,
          "report_ok_name": "",
          "show_report_error_name": false,
          "report_error_name": "",
          "choice_mode": "DEFAULT",
          "warning_name_list": [],
          "images": []
        },
        {
          "success_count": 1,
          "warning_count": 0,
          "identifier": "33108543-560c-4052-b542-56318292f246",
          "group_item_name": "左C柱",
          "show_report_index": false,
          "report_index": 9999,
          "show_report_ok_name": false,
          "report_ok_name": "",
          "show_report_error_name": false,
          "report_error_name": "",
          "choice_mode": "MULTIPLE",
          "warning_name_list": [],
          "images": []
        },
        {
          "success_count": 0,
          "warning_count": 0,
          "identifier": "87543937-b74e-4395-a8d0-091abea280d2",
          "group_item_name": "左C柱_图片",
          "show_report_index": false,
          "report_index": 9999,
          "show_report_ok_name": false,
          "report_ok_name": "",
          "show_report_error_name": false,
          "report_error_name": "",
          "choice_mode": "DEFAULT",
          "warning_name_list": [],
          "images": []
        },
        {
          "success_count": 0,
          "warning_count": 2,
          "identifier": "23558ddf-a977-40c8-bd65-fcecafb037fa",
          "group_item_name": "左后翼子板",
          "show_report_index": false,
          "report_index": 9999,
          "show_report_ok_name": false,
          "report_ok_name": "",
          "show_report_error_name": false,
          "report_error_name": "",
          "choice_mode": "MULTIPLE",
          "warning_name_list": [
            "钣金",
            "喷漆"
          ],
          "images": []
        },
        {
          "success_count": 0,
          "warning_count": 0,
          "identifier": "9b88ced2-928e-42c1-9e7e-e35a1ea22956",
          "group_item_name": "左后翼子板_图片",
          "show_report_index": false,
          "report_index": 9999,
          "show_report_ok_name": false,
          "report_ok_name": "",
          "show_report_error_name": false,
          "report_error_name": "",
          "choice_mode": "DEFAULT",
          "warning_name_list": [],
          "images": []
        },
        {
          "success_count": 1,
          "warning_count": 0,
          "identifier": "72eac315-5668-460b-a4d4-cb672a749616",
          "group_item_name": "后备箱盖",
          "show_report_index": false,
          "report_index": 9999,
          "show_report_ok_name": false,
          "report_ok_name": "",
          "show_report_error_name": false,
          "report_error_name": "",
          "choice_mode": "MULTIPLE",
          "warning_name_list": [],
          "images": []
        },
        {
          "success_count": 0,
          "warning_count": 0,
          "identifier": "d826ef20-b047-43ec-b2d9-8180701d6b45",
          "group_item_name": "后备箱盖_图片",
          "show_report_index": false,
          "report_index": 9999,
          "show_report_ok_name": false,
          "report_ok_name": "",
          "show_report_error_name": false,
          "report_error_name": "",
          "choice_mode": "DEFAULT",
          "warning_name_list": [],
          "images": []
        },
        {
          "success_count": 0,
          "warning_count": 2,
          "identifier": "433a93d7-9698-4086-9940-544b9419cbda",
          "group_item_name": "后保险杠",
          "show_report_index": false,
          "report_index": 9999,
          "show_report_ok_name": false,
          "report_ok_name": "",
          "show_report_error_name": false,
          "report_error_name": "",
          "choice_mode": "MULTIPLE",
          "warning_name_list": [
            "喷漆",
            "拆装"
          ],
          "images": []
        },
        {
          "success_count": 0,
          "warning_count": 0,
          "identifier": "fdfbdd68-f47f-445c-8e3d-e7f0874ac894",
          "group_item_name": "后保险杠_图片",
          "show_report_index": false,
          "report_index": 9999,
          "show_report_ok_name": false,
          "report_ok_name": "",
          "show_report_error_name": false,
          "report_error_name": "",
          "choice_mode": "DEFAULT",
          "warning_name_list": [],
          "images": []
        },
        {
          "success_count": 1,
          "warning_count": 0,
          "identifier": "6a5e99af-7fa6-4bfe-8b55-b9bb3a03d35f",
          "group_item_name": "右后翼子板",
          "show_report_index": false,
          "report_index": 9999,
          "show_report_ok_name": false,
          "report_ok_name": "",
          "show_report_error_name": false,
          "report_error_name": "",
          "choice_mode": "MULTIPLE",
          "warning_name_list": [],
          "images": []
        },
        {
          "success_count": 0,
          "warning_count": 0,
          "identifier": "1a536d12-eb48-4442-93cd-ed75e4ea5b6c",
          "group_item_name": "右后翼子板_图片",
          "show_report_index": false,
          "report_index": 9999,
          "show_report_ok_name": false,
          "report_ok_name": "",
          "show_report_error_name": false,
          "report_error_name": "",
          "choice_mode": "DEFAULT",
          "warning_name_list": [],
          "images": []
        },
        {
          "success_count": 1,
          "warning_count": 0,
          "identifier": "52ff71ba-258c-463c-bf67-e21b42b9535c",
          "group_item_name": "右C柱",
          "show_report_index": false,
          "report_index": 9999,
          "show_report_ok_name": false,
          "report_ok_name": "",
          "show_report_error_name": false,
          "report_error_name": "",
          "choice_mode": "MULTIPLE",
          "warning_name_list": [],
          "images": []
        },
        {
          "success_count": 0,
          "warning_count": 0,
          "identifier": "1dc82fde-15c4-4020-af3b-5ad3c3aa7a27",
          "group_item_name": "右C柱_图片",
          "show_report_index": false,
          "report_index": 9999,
          "show_report_ok_name": false,
          "report_ok_name": "",
          "show_report_error_name": false,
          "report_error_name": "",
          "choice_mode": "DEFAULT",
          "warning_name_list": [],
          "images": []
        },
        {
          "success_count": 1,
          "warning_count": 0,
          "identifier": "f42779aa-14bd-481f-885b-31dfb0f19aaa",
          "group_item_name": "右后门",
          "show_report_index": false,
          "report_index": 9999,
          "show_report_ok_name": false,
          "report_ok_name": "",
          "show_report_error_name": false,
          "report_error_name": "",
          "choice_mode": "MULTIPLE",
          "warning_name_list": [],
          "images": []
        },
        {
          "success_count": 0,
          "warning_count": 0,
          "identifier": "5bd37c22-74c9-4b40-afc8-0828ee0ba620",
          "group_item_name": "右后门_图片",
          "show_report_index": false,
          "report_index": 9999,
          "show_report_ok_name": false,
          "report_ok_name": "",
          "show_report_error_name": false,
          "report_error_name": "",
          "choice_mode": "DEFAULT",
          "warning_name_list": [],
          "images": []
        },
        {
          "success_count": 1,
          "warning_count": 0,
          "identifier": "dce79ddc-4a79-423b-a1a7-10d4c351cfe0",
          "group_item_name": "右B柱",
          "show_report_index": false,
          "report_index": 9999,
          "show_report_ok_name": false,
          "report_ok_name": "",
          "show_report_error_name": false,
          "report_error_name": "",
          "choice_mode": "MULTIPLE",
          "warning_name_list": [],
          "images": []
        },
        {
          "success_count": 0,
          "warning_count": 0,
          "identifier": "3e6301c6-3007-475d-8076-ca17e766d206",
          "group_item_name": "右B柱_图片",
          "show_report_index": false,
          "report_index": 9999,
          "show_report_ok_name": false,
          "report_ok_name": "",
          "show_report_error_name": false,
          "report_error_name": "",
          "choice_mode": "DEFAULT",
          "warning_name_list": [],
          "images": []
        },
        {
          "success_count": 0,
          "warning_count": 1,
          "identifier": "b05aef15-1ad7-4da8-91d2-5387783a5f35",
          "group_item_name": "右前门",
          "show_report_index": false,
          "report_index": 9999,
          "show_report_ok_name": false,
          "report_ok_name": "",
          "show_report_error_name": false,
          "report_error_name": "",
          "choice_mode": "MULTIPLE",
          "warning_name_list": [
            "喷漆"
          ],
          "images": []
        },
        {
          "success_count": 0,
          "warning_count": 0,
          "identifier": "1b7afa6c-bc48-46c9-8b3d-f931c857d076",
          "group_item_name": "右前门_图片",
          "show_report_index": false,
          "report_index": 9999,
          "show_report_ok_name": false,
          "report_ok_name": "",
          "show_report_error_name": false,
          "report_error_name": "",
          "choice_mode": "DEFAULT",
          "warning_name_list": [],
          "images": []
        },
        {
          "success_count": 0,
          "warning_count": 1,
          "identifier": "9182bb9c-7fae-485e-8b5b-5038dff7bcf3",
          "group_item_name": "右A柱",
          "show_report_index": false,
          "report_index": 9999,
          "show_report_ok_name": false,
          "report_ok_name": "",
          "show_report_error_name": false,
          "report_error_name": "",
          "choice_mode": "MULTIPLE",
          "warning_name_list": [
            "喷漆"
          ],
          "images": []
        },
        {
          "success_count": 0,
          "warning_count": 0,
          "identifier": "fb0e6bae-e993-47db-a9bd-3af5e16948da",
          "group_item_name": "右A柱_图片",
          "show_report_index": false,
          "report_index": 9999,
          "show_report_ok_name": false,
          "report_ok_name": "",
          "show_report_error_name": false,
          "report_error_name": "",
          "choice_mode": "DEFAULT",
          "warning_name_list": [],
          "images": []
        },
        {
          "success_count": 0,
          "warning_count": 2,
          "identifier": "38784b23-e38c-46cf-93dd-3ca5c7812a3c",
          "group_item_name": "右前翼子板",
          "show_report_index": false,
          "report_index": 9999,
          "show_report_ok_name": false,
          "report_ok_name": "",
          "show_report_error_name": false,
          "report_error_name": "",
          "choice_mode": "MULTIPLE",
          "warning_name_list": [
            "喷漆",
            "拆装"
          ],
          "images": []
        },
        {
          "success_count": 0,
          "warning_count": 0,
          "identifier": "c374f627-9459-4f18-b0c0-d50930cb0044",
          "group_item_name": "右前翼子板_图片",
          "show_report_index": false,
          "report_index": 9999,
          "show_report_ok_name": false,
          "report_ok_name": "",
          "show_report_error_name": false,
          "report_error_name": "",
          "choice_mode": "DEFAULT",
          "warning_name_list": [],
          "images": []
        },
        {
          "success_count": 0,
          "warning_count": 3,
          "identifier": "18b2bf98-8745-4982-b864-9e9d5e18bdff",
          "group_item_name": "机舱引擎盖",
          "show_report_index": false,
          "report_index": 9999,
          "show_report_ok_name": false,
          "report_ok_name": "",
          "show_report_error_name": false,
          "report_error_name": "",
          "choice_mode": "MULTIPLE",
          "warning_name_list": [
            "喷漆",
            "更换过",
            "拆装"
          ],
          "images": []
        },
        {
          "success_count": 0,
          "warning_count": 0,
          "identifier": "ff5bd3ae-1dc2-400e-83e0-18338ea8bd87",
          "group_item_name": "机舱引擎盖_图片",
          "show_report_index": false,
          "report_index": 9999,
          "show_report_ok_name": false,
          "report_ok_name": "",
          "show_report_error_name": false,
          "report_error_name": "",
          "choice_mode": "DEFAULT",
          "warning_name_list": [],
          "images": []
        },
        {
          "success_count": 1,
          "warning_count": 0,
          "identifier": "2c4b1d55-e4f1-40f5-bc88-ca488779b1a1",
          "group_item_name": "车顶",
          "show_report_index": false,
          "report_index": 9999,
          "show_report_ok_name": false,
          "report_ok_name": "",
          "show_report_error_name": false,
          "report_error_name": "",
          "choice_mode": "MULTIPLE",
          "warning_name_list": [],
          "images": []
        },
        {
          "success_count": 0,
          "warning_count": 0,
          "identifier": "e759e752-1013-4104-9893-c49941819be1",
          "group_item_name": "车顶_图片",
          "show_report_index": false,
          "report_index": 9999,
          "show_report_ok_name": false,
          "report_ok_name": "",
          "show_report_error_name": false,
          "report_error_name": "",
          "choice_mode": "DEFAULT",
          "warning_name_list": [],
          "images": []
        }
      ]
    },
    {
      "group_object_id": "75557df5-d5c4-495f-9cc5-38588b75c328",
      "group_object_group_id": "418740a6-80a8-410d-9895-dcd3dcfb6242",
      "group_name": "加强件检测",
      "group_short_label": "加强",
      "cover_mode": "Default",
      "success_count": 11,
      "warning_count": 5,
      "report_label": null,
      "is_active": true,
      "report_config": {
        "identifier": "ffebbb26-9d47-46ca-9b4b-dfe9918d8ea6",
        "report_print_index": 0,
        "show_print_report_icon": false,
        "show_print_report_table": true,
        "show_in_print_report": true,
        "page_break": true,
        "head_page_break": false,
        "test_result_min_height": 180,
        "page_bottom": "0"
      },
      "test_result": null,
      "detected": true,
      "items": [
        {
          "success_count": 0,
          "warning_count": 2,
          "identifier": "fe572062-628a-4854-88dd-d2c05125c81b",
          "group_item_name": "前防撞梁",
          "show_report_index": false,
          "report_index": 9999,
          "show_report_ok_name": false,
          "report_ok_name": "",
          "show_report_error_name": false,
          "report_error_name": "",
          "choice_mode": "MULTIPLE",
          "warning_name_list": [
            "曾更换",
            "拆装"
          ],
          "images": []
        },
        {
          "success_count": 0,
          "warning_count": 0,
          "identifier": "58bd3409-9331-4c2f-a834-ddecc4872320",
          "group_item_name": "前防撞梁_图片",
          "show_report_index": false,
          "report_index": 9999,
          "show_report_ok_name": false,
          "report_ok_name": "",
          "show_report_error_name": false,
          "report_error_name": "",
          "choice_mode": "DEFAULT",
          "warning_name_list": [],
          "images": []
        },
        {
          "success_count": 0,
          "warning_count": 2,
          "identifier": "a4c51865-f7a3-4c3d-a2f4-3520ea0436ac",
          "group_item_name": "水箱框架",
          "show_report_index": false,
          "report_index": 9999,
          "show_report_ok_name": false,
          "report_ok_name": "",
          "show_report_error_name": false,
          "report_error_name": "",
          "choice_mode": "MULTIPLE",
          "warning_name_list": [
            "曾更换",
            "拆装"
          ],
          "images": []
        },
        {
          "success_count": 0,
          "warning_count": 0,
          "identifier": "dcf05d69-dbbf-48a7-a5a3-d5d4196fc5d9",
          "group_item_name": "水箱框架_图片",
          "show_report_index": false,
          "report_index": 9999,
          "show_report_ok_name": false,
          "report_ok_name": "",
          "show_report_error_name": false,
          "report_error_name": "",
          "choice_mode": "DEFAULT",
          "warning_name_list": [],
          "images": []
        },
        {
          "success_count": 0,
          "warning_count": 2,
          "identifier": "a4f5fd0f-1b15-4c49-bc65-b099b693625d",
          "group_item_name": "左前大灯框",
          "show_report_index": false,
          "report_index": 9999,
          "show_report_ok_name": false,
          "report_ok_name": "",
          "show_report_error_name": false,
          "report_error_name": "",
          "choice_mode": "MULTIPLE",
          "warning_name_list": [
            "曾更换",
            "拆装"
          ],
          "images": []
        },
        {
          "success_count": 0,
          "warning_count": 0,
          "identifier": "c11c00f8-937e-42bc-aa47-a80ef7d57033",
          "group_item_name": "左前大灯框_图片",
          "show_report_index": false,
          "report_index": 9999,
          "show_report_ok_name": false,
          "report_ok_name": "",
          "show_report_error_name": false,
          "report_error_name": "",
          "choice_mode": "DEFAULT",
          "warning_name_list": [],
          "images": []
        },
        {
          "success_count": 1,
          "warning_count": 0,
          "identifier": "acd18cb3-3742-43ed-add5-ef90d51371c6",
          "group_item_name": "左前加强梁",
          "show_report_index": false,
          "report_index": 9999,
          "show_report_ok_name": false,
          "report_ok_name": "",
          "show_report_error_name": false,
          "report_error_name": "",
          "choice_mode": "MULTIPLE",
          "warning_name_list": [],
          "images": []
        },
        {
          "success_count": 0,
          "warning_count": 0,
          "identifier": "5f71ac1c-1728-434e-81df-7535b1fd782c",
          "group_item_name": "左前加强梁_图片",
          "show_report_index": false,
          "report_index": 9999,
          "show_report_ok_name": false,
          "report_ok_name": "",
          "show_report_error_name": false,
          "report_error_name": "",
          "choice_mode": "DEFAULT",
          "warning_name_list": [],
          "images": []
        },
        {
          "success_count": 1,
          "warning_count": 0,
          "identifier": "e11de46c-570e-4235-a6a0-206d663e1495",
          "group_item_name": "左前翼子板内衬",
          "show_report_index": false,
          "report_index": 9999,
          "show_report_ok_name": false,
          "report_ok_name": "",
          "show_report_error_name": false,
          "report_error_name": "",
          "choice_mode": "MULTIPLE",
          "warning_name_list": [],
          "images": []
        },
        {
          "success_count": 0,
          "warning_count": 0,
          "identifier": "8d53ed95-4757-4737-8ea1-9d2d765aab52",
          "group_item_name": "左前翼子板内衬_图片",
          "show_report_index": false,
          "report_index": 9999,
          "show_report_ok_name": false,
          "report_ok_name": "",
          "show_report_error_name": false,
          "report_error_name": "",
          "choice_mode": "DEFAULT",
          "warning_name_list": [],
          "images": []
        },
        {
          "success_count": 0,
          "warning_count": 2,
          "identifier": "f29948b7-87dd-44de-9204-f4fbc745abf8",
          "group_item_name": "右前大灯框",
          "show_report_index": false,
          "report_index": 9999,
          "show_report_ok_name": false,
          "report_ok_name": "",
          "show_report_error_name": false,
          "report_error_name": "",
          "choice_mode": "MULTIPLE",
          "warning_name_list": [
            "曾更换",
            "拆装"
          ],
          "images": []
        },
        {
          "success_count": 0,
          "warning_count": 0,
          "identifier": "8776947c-2c09-44eb-88be-8f949a36f93b",
          "group_item_name": "右前大灯框_图片",
          "show_report_index": false,
          "report_index": 9999,
          "show_report_ok_name": false,
          "report_ok_name": "",
          "show_report_error_name": false,
          "report_error_name": "",
          "choice_mode": "DEFAULT",
          "warning_name_list": [],
          "images": []
        },
        {
          "success_count": 1,
          "warning_count": 0,
          "identifier": "cb3e7ca9-c4e6-4bcf-8bac-0bfa482f4aca",
          "group_item_name": "右前加强梁",
          "show_report_index": false,
          "report_index": 9999,
          "show_report_ok_name": false,
          "report_ok_name": "",
          "show_report_error_name": false,
          "report_error_name": "",
          "choice_mode": "MULTIPLE",
          "warning_name_list": [],
          "images": []
        },
        {
          "success_count": 0,
          "warning_count": 0,
          "identifier": "a6030e97-9b8f-4c0d-804c-ff9d2db51f0d",
          "group_item_name": "右前加强梁_图片",
          "show_report_index": false,
          "report_index": 9999,
          "show_report_ok_name": false,
          "report_ok_name": "",
          "show_report_error_name": false,
          "report_error_name": "",
          "choice_mode": "DEFAULT",
          "warning_name_list": [],
          "images": []
        },
        {
          "success_count": 0,
          "warning_count": 1,
          "identifier": "83ef5768-91f8-474d-9907-11fe4e136e03",
          "group_item_name": "右前翼子板内衬",
          "show_report_index": false,
          "report_index": 9999,
          "show_report_ok_name": false,
          "report_ok_name": "",
          "show_report_error_name": false,
          "report_error_name": "",
          "choice_mode": "MULTIPLE",
          "warning_name_list": [
            "修复"
          ],
          "images": []
        },
        {
          "success_count": 0,
          "warning_count": 0,
          "identifier": "c8fd485c-ec2b-45a7-aef3-63b3e71286d2",
          "group_item_name": "右前翼子板内衬_图片",
          "show_report_index": false,
          "report_index": 9999,
          "show_report_ok_name": false,
          "report_ok_name": "",
          "show_report_error_name": false,
          "report_error_name": "",
          "choice_mode": "DEFAULT",
          "warning_name_list": [],
          "images": []
        },
        {
          "success_count": 1,
          "warning_count": 0,
          "identifier": "e64f0cb6-c256-4a7e-9937-263048b0e90c",
          "group_item_name": "导雨槽",
          "show_report_index": false,
          "report_index": 9999,
          "show_report_ok_name": false,
          "report_ok_name": "",
          "show_report_error_name": false,
          "report_error_name": "",
          "choice_mode": "MULTIPLE",
          "warning_name_list": [],
          "images": []
        },
        {
          "success_count": 0,
          "warning_count": 0,
          "identifier": "47b3e555-6016-4bc9-bbaa-9a1a7ba58e10",
          "group_item_name": "导雨槽_图片",
          "show_report_index": false,
          "report_index": 9999,
          "show_report_ok_name": false,
          "report_ok_name": "",
          "show_report_error_name": false,
          "report_error_name": "",
          "choice_mode": "DEFAULT",
          "warning_name_list": [],
          "images": []
        },
        {
          "success_count": 1,
          "warning_count": 0,
          "identifier": "fda3fb27-905a-422e-aaaa-726c21d1f112",
          "group_item_name": "左后翼子板内衬",
          "show_report_index": false,
          "report_index": 9999,
          "show_report_ok_name": false,
          "report_ok_name": "",
          "show_report_error_name": false,
          "report_error_name": "",
          "choice_mode": "MULTIPLE",
          "warning_name_list": [],
          "images": []
        },
        {
          "success_count": 0,
          "warning_count": 0,
          "identifier": "9cf675a4-e8ce-479d-beae-9199476a2972",
          "group_item_name": "左后翼子板内衬_图片",
          "show_report_index": false,
          "report_index": 9999,
          "show_report_ok_name": false,
          "report_ok_name": "",
          "show_report_error_name": false,
          "report_error_name": "",
          "choice_mode": "DEFAULT",
          "warning_name_list": [],
          "images": []
        },
        {
          "success_count": 1,
          "warning_count": 0,
          "identifier": "9650f7c5-1247-48dd-ac0d-7aa1ab0094a4",
          "group_item_name": "左后大灯框",
          "show_report_index": false,
          "report_index": 9999,
          "show_report_ok_name": false,
          "report_ok_name": "",
          "show_report_error_name": false,
          "report_error_name": "",
          "choice_mode": "MULTIPLE",
          "warning_name_list": [],
          "images": []
        },
        {
          "success_count": 0,
          "warning_count": 0,
          "identifier": "616621e4-a08d-49cc-a140-b8da942c8ce4",
          "group_item_name": "左后大灯框_图片",
          "show_report_index": false,
          "report_index": 9999,
          "show_report_ok_name": false,
          "report_ok_name": "",
          "show_report_error_name": false,
          "report_error_name": "",
          "choice_mode": "DEFAULT",
          "warning_name_list": [],
          "images": []
        },
        {
          "success_count": 1,
          "warning_count": 0,
          "identifier": "9b858719-e967-48b7-b5ce-b39bc1522152",
          "group_item_name": "右后翼子板内衬",
          "show_report_index": false,
          "report_index": 9999,
          "show_report_ok_name": false,
          "report_ok_name": "",
          "show_report_error_name": false,
          "report_error_name": "",
          "choice_mode": "MULTIPLE",
          "warning_name_list": [],
          "images": []
        },
        {
          "success_count": 0,
          "warning_count": 0,
          "identifier": "985f177a-ca5c-4432-b7ec-a87df0123eb0",
          "group_item_name": "右后翼子板内衬_图片",
          "show_report_index": false,
          "report_index": 9999,
          "show_report_ok_name": false,
          "report_ok_name": "",
          "show_report_error_name": false,
          "report_error_name": "",
          "choice_mode": "DEFAULT",
          "warning_name_list": [],
          "images": []
        },
        {
          "success_count": 1,
          "warning_count": 0,
          "identifier": "8afd6679-f185-4428-9338-b5c3c1c67347",
          "group_item_name": "右后大灯框",
          "show_report_index": false,
          "report_index": 9999,
          "show_report_ok_name": false,
          "report_ok_name": "",
          "show_report_error_name": false,
          "report_error_name": "",
          "choice_mode": "MULTIPLE",
          "warning_name_list": [],
          "images": []
        },
        {
          "success_count": 0,
          "warning_count": 0,
          "identifier": "b38f69a8-dd69-4183-8d2c-722b4d9d7d80",
          "group_item_name": "右后大灯框_图片",
          "show_report_index": false,
          "report_index": 9999,
          "show_report_ok_name": false,
          "report_ok_name": "",
          "show_report_error_name": false,
          "report_error_name": "",
          "choice_mode": "DEFAULT",
          "warning_name_list": [],
          "images": []
        },
        {
          "success_count": 1,
          "warning_count": 0,
          "identifier": "4c77b902-21e5-4965-8dfb-b9e8a9efa3e7",
          "group_item_name": "车身后尾板",
          "show_report_index": false,
          "report_index": 9999,
          "show_report_ok_name": false,
          "report_ok_name": "",
          "show_report_error_name": false,
          "report_error_name": "",
          "choice_mode": "MULTIPLE",
          "warning_name_list": [],
          "images": []
        },
        {
          "success_count": 0,
          "warning_count": 0,
          "identifier": "c5141901-0dc8-46aa-b6e6-41b243520291",
          "group_item_name": "车身后尾板_图片",
          "show_report_index": false,
          "report_index": 9999,
          "show_report_ok_name": false,
          "report_ok_name": "",
          "show_report_error_name": false,
          "report_error_name": "",
          "choice_mode": "DEFAULT",
          "warning_name_list": [],
          "images": []
        },
        {
          "success_count": 1,
          "warning_count": 0,
          "identifier": "950216b5-fb44-4431-a628-78bcc8bfe301",
          "group_item_name": "后防撞梁",
          "show_report_index": false,
          "report_index": 9999,
          "show_report_ok_name": false,
          "report_ok_name": "",
          "show_report_error_name": false,
          "report_error_name": "",
          "choice_mode": "MULTIPLE",
          "warning_name_list": [],
          "images": []
        },
        {
          "success_count": 0,
          "warning_count": 0,
          "identifier": "dc912dca-6f27-4500-aed5-00be638f462f",
          "group_item_name": "后防撞梁_图片",
          "show_report_index": false,
          "report_index": 9999,
          "show_report_ok_name": false,
          "report_ok_name": "",
          "show_report_error_name": false,
          "report_error_name": "",
          "choice_mode": "DEFAULT",
          "warning_name_list": [],
          "images": []
        },
        {
          "success_count": 0,
          "warning_count": 0,
          "identifier": "561ec514-98bb-4f93-9499-4f7282882d99",
          "group_item_name": "备胎槽_图片",
          "show_report_index": false,
          "report_index": 9999,
          "show_report_ok_name": false,
          "report_ok_name": "",
          "show_report_error_name": false,
          "report_error_name": "",
          "choice_mode": "DEFAULT",
          "warning_name_list": [],
          "images": []
        },
        {
          "success_count": 1,
          "warning_count": 0,
          "identifier": "3ab423ee-7a0e-47e6-af86-00191901dbb4",
          "group_item_name": "备胎槽",
          "show_report_index": false,
          "report_index": 9999,
          "show_report_ok_name": false,
          "report_ok_name": "正常",
          "show_report_error_name": false,
          "report_error_name": "异常",
          "choice_mode": "MULTIPLE",
          "warning_name_list": [],
          "images": []
        }
      ]
    },
    {
      "group_object_id": "b29ec93e-53cc-4c8f-8181-e2df1114c0da",
      "group_object_group_id": "39e5698e-9c45-4467-916f-c724d1075816",
      "group_name": "结构件检测",
      "group_short_label": "结构",
      "cover_mode": "Arch",
      "success_count": 20,
      "warning_count": 0,
      "report_label": null,
      "is_active": true,
      "report_config": {
        "identifier": "265ad6f3-3c38-4a12-90fd-9eb1169c1a87",
        "report_print_index": 9999,
        "show_print_report_icon": true,
        "show_print_report_table": true,
        "show_in_print_report": true,
        "page_break": false,
        "head_page_break": true,
        "test_result_min_height": 275,
        "page_bottom": "0"
      },
      "cover_url": "https://chezhibao.ltd/media/xy_django_app_resource/images/ok_1_Xc7klM5.png",
      "test_result": null,
      "detected": true,
      "items": [
        {
          "success_count": 1,
          "warning_count": 0,
          "identifier": "74cc562b-3f69-46c7-a69b-db71f043d1df",
          "group_item_name": "前横梁",
          "show_report_index": true,
          "report_index": 1,
          "show_report_ok_name": false,
          "report_ok_name": "",
          "show_report_error_name": false,
          "report_error_name": "",
          "choice_mode": "MULTIPLE",
          "warning_name_list": [],
          "images": []
        },
        {
          "success_count": 0,
          "warning_count": 0,
          "identifier": "144e342e-f78c-4f55-aa27-58d1c52a8ac5",
          "group_item_name": "前横梁_图片",
          "show_report_index": false,
          "report_index": 9999,
          "show_report_ok_name": false,
          "report_ok_name": "",
          "show_report_error_name": false,
          "report_error_name": "",
          "choice_mode": "DEFAULT",
          "warning_name_list": [],
          "images": []
        },
        {
          "success_count": 1,
          "warning_count": 0,
          "identifier": "8d2f0869-ffdf-4711-b568-74b39a7768a8",
          "group_item_name": "右前纵梁",
          "show_report_index": true,
          "report_index": 2,
          "show_report_ok_name": false,
          "report_ok_name": "",
          "show_report_error_name": false,
          "report_error_name": "",
          "choice_mode": "MULTIPLE",
          "warning_name_list": [],
          "images": []
        },
        {
          "success_count": 0,
          "warning_count": 0,
          "identifier": "712a71ee-f63a-42a6-9efe-c70811e174f5",
          "group_item_name": "右前纵梁_图片",
          "show_report_index": false,
          "report_index": 9999,
          "show_report_ok_name": false,
          "report_ok_name": "",
          "show_report_error_name": false,
          "report_error_name": "",
          "choice_mode": "DEFAULT",
          "warning_name_list": [],
          "images": []
        },
        {
          "success_count": 1,
          "warning_count": 0,
          "identifier": "50f38810-f448-4887-a6a0-183df24baf46",
          "group_item_name": "右前减震座",
          "show_report_index": true,
          "report_index": 3,
          "show_report_ok_name": false,
          "report_ok_name": "",
          "show_report_error_name": false,
          "report_error_name": "",
          "choice_mode": "MULTIPLE",
          "warning_name_list": [],
          "images": []
        },
        {
          "success_count": 0,
          "warning_count": 0,
          "identifier": "f0771402-837e-413b-b317-0eae92a0a6b6",
          "group_item_name": "右前减震座_图片",
          "show_report_index": false,
          "report_index": 9999,
          "show_report_ok_name": false,
          "report_ok_name": "",
          "show_report_error_name": false,
          "report_error_name": "",
          "choice_mode": "DEFAULT",
          "warning_name_list": [],
          "images": []
        },
        {
          "success_count": 1,
          "warning_count": 0,
          "identifier": "fdfd606a-2361-45b6-b34e-3ad2c41d4158",
          "group_item_name": "右侧A柱",
          "show_report_index": true,
          "report_index": 4,
          "show_report_ok_name": false,
          "report_ok_name": "",
          "show_report_error_name": false,
          "report_error_name": "",
          "choice_mode": "MULTIPLE",
          "warning_name_list": [],
          "images": []
        },
        {
          "success_count": 0,
          "warning_count": 0,
          "identifier": "19857a5c-08c1-4d04-8e7c-e281e01974b0",
          "group_item_name": "右侧A柱_图片",
          "show_report_index": false,
          "report_index": 9999,
          "show_report_ok_name": false,
          "report_ok_name": "",
          "show_report_error_name": false,
          "report_error_name": "",
          "choice_mode": "DEFAULT",
          "warning_name_list": [],
          "images": []
        },
        {
          "success_count": 1,
          "warning_count": 0,
          "identifier": "68d96816-2aef-499d-bae3-a52ce4601631",
          "group_item_name": "防火墙",
          "show_report_index": true,
          "report_index": 5,
          "show_report_ok_name": false,
          "report_ok_name": "",
          "show_report_error_name": false,
          "report_error_name": "",
          "choice_mode": "MULTIPLE",
          "warning_name_list": [],
          "images": []
        },
        {
          "success_count": 0,
          "warning_count": 0,
          "identifier": "f2b2117f-807e-43c8-a6e8-84876a1842bd",
          "group_item_name": "防火墙_图片",
          "show_report_index": false,
          "report_index": 9999,
          "show_report_ok_name": false,
          "report_ok_name": "",
          "show_report_error_name": false,
          "report_error_name": "",
          "choice_mode": "DEFAULT",
          "warning_name_list": [],
          "images": []
        },
        {
          "success_count": 1,
          "warning_count": 0,
          "identifier": "947d84c4-ff0a-4184-93bd-b4abd67fa27f",
          "group_item_name": "右侧B柱",
          "show_report_index": true,
          "report_index": 6,
          "show_report_ok_name": false,
          "report_ok_name": "",
          "show_report_error_name": false,
          "report_error_name": "",
          "choice_mode": "MULTIPLE",
          "warning_name_list": [],
          "images": []
        },
        {
          "success_count": 0,
          "warning_count": 0,
          "identifier": "e168100b-60a5-400f-8b44-a4cd6e4e1598",
          "group_item_name": "右侧B柱_图片",
          "show_report_index": false,
          "report_index": 9999,
          "show_report_ok_name": false,
          "report_ok_name": "",
          "show_report_error_name": false,
          "report_error_name": "",
          "choice_mode": "DEFAULT",
          "warning_name_list": [],
          "images": []
        },
        {
          "success_count": 1,
          "warning_count": 0,
          "identifier": "498adf74-3647-4bed-b2b8-06ead6221abf",
          "group_item_name": "右侧C柱",
          "show_report_index": true,
          "report_index": 7,
          "show_report_ok_name": false,
          "report_ok_name": "",
          "show_report_error_name": false,
          "report_error_name": "",
          "choice_mode": "MULTIPLE",
          "warning_name_list": [],
          "images": []
        },
        {
          "success_count": 0,
          "warning_count": 0,
          "identifier": "c77b01ac-5a78-4118-a812-e626ac2c5d95",
          "group_item_name": "右侧C柱_图片",
          "show_report_index": false,
          "report_index": 9999,
          "show_report_ok_name": false,
          "report_ok_name": "",
          "show_report_error_name": false,
          "report_error_name": "",
          "choice_mode": "DEFAULT",
          "warning_name_list": [],
          "images": []
        },
        {
          "success_count": 1,
          "warning_count": 0,
          "identifier": "7063271c-c3e3-44c0-ae17-2ebfe273389d",
          "group_item_name": "右后减震座",
          "show_report_index": true,
          "report_index": 8,
          "show_report_ok_name": false,
          "report_ok_name": "",
          "show_report_error_name": false,
          "report_error_name": "",
          "choice_mode": "MULTIPLE",
          "warning_name_list": [],
          "images": []
        },
        {
          "success_count": 0,
          "warning_count": 0,
          "identifier": "977ee2c3-ead7-43c5-a368-672c26cccd3b",
          "group_item_name": "右后减震座_图片",
          "show_report_index": false,
          "report_index": 9999,
          "show_report_ok_name": false,
          "report_ok_name": "",
          "show_report_error_name": false,
          "report_error_name": "",
          "choice_mode": "DEFAULT",
          "warning_name_list": [],
          "images": []
        },
        {
          "success_count": 1,
          "warning_count": 0,
          "identifier": "a58f3420-fe09-48eb-b168-6047bfc3cfb4",
          "group_item_name": "右后纵梁",
          "show_report_index": true,
          "report_index": 9,
          "show_report_ok_name": false,
          "report_ok_name": "",
          "show_report_error_name": false,
          "report_error_name": "",
          "choice_mode": "MULTIPLE",
          "warning_name_list": [],
          "images": []
        },
        {
          "success_count": 0,
          "warning_count": 0,
          "identifier": "8b457c62-a1a9-490d-8a5e-6ad966a4fc83",
          "group_item_name": "右后纵梁_图片",
          "show_report_index": false,
          "report_index": 9999,
          "show_report_ok_name": false,
          "report_ok_name": "",
          "show_report_error_name": false,
          "report_error_name": "",
          "choice_mode": "DEFAULT",
          "warning_name_list": [],
          "images": [
            "https://chezhibao.ltd/media/Resource/Image/images/tmpph707gx8.png"
          ]
        },
        {
          "success_count": 1,
          "warning_count": 0,
          "identifier": "27ffe1fb-c8ab-4167-a5bf-2a3b641365c1",
          "group_item_name": "后备箱底板",
          "show_report_index": true,
          "report_index": 10,
          "show_report_ok_name": false,
          "report_ok_name": "",
          "show_report_error_name": false,
          "report_error_name": "",
          "choice_mode": "MULTIPLE",
          "warning_name_list": [],
          "images": []
        },
        {
          "success_count": 0,
          "warning_count": 0,
          "identifier": "538a8fca-23fe-4d4c-bfb0-1f6d0c602e87",
          "group_item_name": "后备箱底板_图片",
          "show_report_index": false,
          "report_index": 9999,
          "show_report_ok_name": false,
          "report_ok_name": "",
          "show_report_error_name": false,
          "report_error_name": "",
          "choice_mode": "DEFAULT",
          "warning_name_list": [],
          "images": []
        },
        {
          "success_count": 1,
          "warning_count": 0,
          "identifier": "eb4963b8-7d27-42cb-b361-0643de5e1254",
          "group_item_name": "左前纵梁",
          "show_report_index": true,
          "report_index": 11,
          "show_report_ok_name": false,
          "report_ok_name": "",
          "show_report_error_name": false,
          "report_error_name": "",
          "choice_mode": "MULTIPLE",
          "warning_name_list": [],
          "images": []
        },
        {
          "success_count": 0,
          "warning_count": 0,
          "identifier": "a5185ed3-46ea-4d3f-9e95-8d25401356ba",
          "group_item_name": "左前纵梁_图片",
          "show_report_index": false,
          "report_index": 9999,
          "show_report_ok_name": false,
          "report_ok_name": "",
          "show_report_error_name": false,
          "report_error_name": "",
          "choice_mode": "DEFAULT",
          "warning_name_list": [],
          "images": []
        },
        {
          "success_count": 1,
          "warning_count": 0,
          "identifier": "4afcfe3b-ea62-41c3-8269-592a97ba06b1",
          "group_item_name": "左前减震座",
          "show_report_index": true,
          "report_index": 12,
          "show_report_ok_name": false,
          "report_ok_name": "",
          "show_report_error_name": false,
          "report_error_name": "",
          "choice_mode": "MULTIPLE",
          "warning_name_list": [],
          "images": []
        },
        {
          "success_count": 0,
          "warning_count": 0,
          "identifier": "14b03b96-b3f8-46f7-ba75-86d3e41f3ae2",
          "group_item_name": "左前减震座_图片",
          "show_report_index": false,
          "report_index": 9999,
          "show_report_ok_name": false,
          "report_ok_name": "",
          "show_report_error_name": false,
          "report_error_name": "",
          "choice_mode": "DEFAULT",
          "warning_name_list": [],
          "images": []
        },
        {
          "success_count": 1,
          "warning_count": 0,
          "identifier": "357fb38a-f747-4e1c-a1f9-52c4d1491a8d",
          "group_item_name": "左侧A柱",
          "show_report_index": true,
          "report_index": 13,
          "show_report_ok_name": false,
          "report_ok_name": "",
          "show_report_error_name": false,
          "report_error_name": "",
          "choice_mode": "MULTIPLE",
          "warning_name_list": [],
          "images": []
        },
        {
          "success_count": 0,
          "warning_count": 0,
          "identifier": "1dcaeeff-ce34-4ac6-b657-dac807e0ed59",
          "group_item_name": "左侧A柱_图片",
          "show_report_index": false,
          "report_index": 9999,
          "show_report_ok_name": false,
          "report_ok_name": "",
          "show_report_error_name": false,
          "report_error_name": "",
          "choice_mode": "DEFAULT",
          "warning_name_list": [],
          "images": []
        },
        {
          "success_count": 1,
          "warning_count": 0,
          "identifier": "60e0f18f-e35d-4deb-b117-52c08d7122b3",
          "group_item_name": "驾驶舱底板",
          "show_report_index": true,
          "report_index": 14,
          "show_report_ok_name": false,
          "report_ok_name": "",
          "show_report_error_name": false,
          "report_error_name": "",
          "choice_mode": "MULTIPLE",
          "warning_name_list": [],
          "images": []
        },
        {
          "success_count": 0,
          "warning_count": 0,
          "identifier": "7c71b7f8-4f66-4845-8d50-d04737551822",
          "group_item_name": "驾驶舱底板_图片",
          "show_report_index": false,
          "report_index": 9999,
          "show_report_ok_name": false,
          "report_ok_name": "",
          "show_report_error_name": false,
          "report_error_name": "",
          "choice_mode": "DEFAULT",
          "warning_name_list": [],
          "images": []
        },
        {
          "success_count": 1,
          "warning_count": 0,
          "identifier": "ce8b7bf0-af94-4510-bc4f-b1c8ef6d748d",
          "group_item_name": "左侧B柱",
          "show_report_index": true,
          "report_index": 15,
          "show_report_ok_name": false,
          "report_ok_name": "",
          "show_report_error_name": false,
          "report_error_name": "",
          "choice_mode": "MULTIPLE",
          "warning_name_list": [],
          "images": []
        },
        {
          "success_count": 0,
          "warning_count": 0,
          "identifier": "32682daa-b20f-481c-87c5-4ad665304316",
          "group_item_name": "左侧B柱_图片",
          "show_report_index": false,
          "report_index": 9999,
          "show_report_ok_name": false,
          "report_ok_name": "",
          "show_report_error_name": false,
          "report_error_name": "",
          "choice_mode": "DEFAULT",
          "warning_name_list": [],
          "images": []
        },
        {
          "success_count": 1,
          "warning_count": 0,
          "identifier": "ec4a4340-2ada-42c9-a56e-5cfae4041ae6",
          "group_item_name": "后隔板",
          "show_report_index": true,
          "report_index": 16,
          "show_report_ok_name": false,
          "report_ok_name": "",
          "show_report_error_name": false,
          "report_error_name": "",
          "choice_mode": "MULTIPLE",
          "warning_name_list": [],
          "images": []
        },
        {
          "success_count": 0,
          "warning_count": 0,
          "identifier": "b31e1877-a0a8-41f4-8aa0-776e99319312",
          "group_item_name": "后隔板_图片",
          "show_report_index": false,
          "report_index": 9999,
          "show_report_ok_name": false,
          "report_ok_name": "",
          "show_report_error_name": false,
          "report_error_name": "",
          "choice_mode": "DEFAULT",
          "warning_name_list": [],
          "images": []
        },
        {
          "success_count": 1,
          "warning_count": 0,
          "identifier": "3dc2ecd2-7731-400e-822c-737581b3c6a6",
          "group_item_name": "后横梁",
          "show_report_index": true,
          "report_index": 17,
          "show_report_ok_name": false,
          "report_ok_name": "",
          "show_report_error_name": false,
          "report_error_name": "",
          "choice_mode": "MULTIPLE",
          "warning_name_list": [],
          "images": []
        },
        {
          "success_count": 0,
          "warning_count": 0,
          "identifier": "f68ad116-b83e-4e62-a7e1-be14a25e3153",
          "group_item_name": "后横梁_图片",
          "show_report_index": false,
          "report_index": 9999,
          "show_report_ok_name": false,
          "report_ok_name": "",
          "show_report_error_name": false,
          "report_error_name": "",
          "choice_mode": "DEFAULT",
          "warning_name_list": [],
          "images": []
        },
        {
          "success_count": 1,
          "warning_count": 0,
          "identifier": "654e4965-c499-47c0-86bb-a5919dcfabdd",
          "group_item_name": "左侧C柱",
          "show_report_index": true,
          "report_index": 18,
          "show_report_ok_name": false,
          "report_ok_name": "",
          "show_report_error_name": false,
          "report_error_name": "",
          "choice_mode": "MULTIPLE",
          "warning_name_list": [],
          "images": []
        },
        {
          "success_count": 0,
          "warning_count": 0,
          "identifier": "ade97687-351d-4bca-9bea-98f85ba19c1f",
          "group_item_name": "左侧C柱_图片",
          "show_report_index": false,
          "report_index": 9999,
          "show_report_ok_name": false,
          "report_ok_name": "",
          "show_report_error_name": false,
          "report_error_name": "",
          "choice_mode": "DEFAULT",
          "warning_name_list": [],
          "images": []
        },
        {
          "success_count": 1,
          "warning_count": 0,
          "identifier": "45e3d9fe-6d5a-4447-884c-ccf5111bbecb",
          "group_item_name": "左后减震座",
          "show_report_index": true,
          "report_index": 19,
          "show_report_ok_name": false,
          "report_ok_name": "",
          "show_report_error_name": false,
          "report_error_name": "",
          "choice_mode": "MULTIPLE",
          "warning_name_list": [],
          "images": []
        },
        {
          "success_count": 0,
          "warning_count": 0,
          "identifier": "841027d7-35e3-4292-92dc-971f38fa5fee",
          "group_item_name": "左后减震座_图片",
          "show_report_index": false,
          "report_index": 9999,
          "show_report_ok_name": false,
          "report_ok_name": "",
          "show_report_error_name": false,
          "report_error_name": "",
          "choice_mode": "DEFAULT",
          "warning_name_list": [],
          "images": []
        },
        {
          "success_count": 1,
          "warning_count": 0,
          "identifier": "be31ea97-a384-49d5-9cb5-49b99438dd85",
          "group_item_name": "左后纵梁",
          "show_report_index": true,
          "report_index": 20,
          "show_report_ok_name": false,
          "report_ok_name": "",
          "show_report_error_name": false,
          "report_error_name": "",
          "choice_mode": "MULTIPLE",
          "warning_name_list": [],
          "images": []
        },
        {
          "success_count": 0,
          "warning_count": 0,
          "identifier": "c7e6388b-49fa-4a4b-a5ab-114038bdc2c5",
          "group_item_name": "左后纵梁_图片",
          "show_report_index": false,
          "report_index": 9999,
          "show_report_ok_name": false,
          "report_ok_name": "",
          "show_report_error_name": false,
          "report_error_name": "",
          "choice_mode": "DEFAULT",
          "warning_name_list": [],
          "images": [
            "https://chezhibao.ltd/media/Resource/Image/images/tmpv64xdanw.png"
          ]
        }
      ]
    },
    {
      "group_object_id": "e98948f7-9e99-4377-9649-cfe81a667c64",
      "group_object_group_id": "04a46f2f-33ea-4e80-ae08-7038ce6985b5",
      "group_name": "泡水检测",
      "group_short_label": "泡水",
      "cover_mode": "Icon",
      "success_count": 20,
      "warning_count": 0,
      "report_label": null,
      "is_active": true,
      "report_config": {
        "identifier": "346365f7-aead-4502-98cc-3ed8e0fe5c9b",
        "report_print_index": 9999,
        "show_print_report_icon": true,
        "show_print_report_table": true,
        "show_in_print_report": true,
        "page_break": false,
        "head_page_break": true,
        "test_result_min_height": 400,
        "page_bottom": "0"
      },
      "cover_url": "https://chezhibao.ltd/media/xy_django_app_resource/images/%E6%B3%A1%E6%B0%B4.png",
      "test_result": null,
      "detected": true,
      "items": [
        {
          "success_count": 1,
          "warning_count": 0,
          "identifier": "db05b812-2d18-4e35-aa10-921f7404fd46",
          "group_item_name": "发动机机舱表面",
          "show_report_index": false,
          "report_index": 9999,
          "show_report_ok_name": false,
          "report_ok_name": "",
          "show_report_error_name": false,
          "report_error_name": "",
          "choice_mode": "MULTIPLE",
          "warning_name_list": [],
          "images": []
        },
        {
          "success_count": 0,
          "warning_count": 0,
          "identifier": "fdeacf91-d932-4fa3-b8a3-2f9dd990d513",
          "group_item_name": "发动机机舱表面_图片",
          "show_report_index": false,
          "report_index": 9999,
          "show_report_ok_name": false,
          "report_ok_name": "",
          "show_report_error_name": false,
          "report_error_name": "",
          "choice_mode": "DEFAULT",
          "warning_name_list": [],
          "images": []
        },
        {
          "success_count": 1,
          "warning_count": 0,
          "identifier": "14855444-272f-404f-b68b-2654d83e9cb1",
          "group_item_name": "防火墙与车内隔音棉",
          "show_report_index": false,
          "report_index": 9999,
          "show_report_ok_name": false,
          "report_ok_name": "",
          "show_report_error_name": false,
          "report_error_name": "",
          "choice_mode": "MULTIPLE",
          "warning_name_list": [],
          "images": []
        },
        {
          "success_count": 0,
          "warning_count": 0,
          "identifier": "cb3dbfb3-98c8-4e35-80f0-d0424b36ecf4",
          "group_item_name": "防火墙与车内隔音棉_图片",
          "show_report_index": false,
          "report_index": 9999,
          "show_report_ok_name": false,
          "report_ok_name": "",
          "show_report_error_name": false,
          "report_error_name": "",
          "choice_mode": "DEFAULT",
          "warning_name_list": [],
          "images": []
        },
        {
          "success_count": 1,
          "warning_count": 0,
          "identifier": "2dfcb2fb-38b2-4ad6-bc1f-1d73dd21d319",
          "group_item_name": "机舱线速及插头",
          "show_report_index": false,
          "report_index": 9999,
          "show_report_ok_name": false,
          "report_ok_name": "",
          "show_report_error_name": false,
          "report_error_name": "",
          "choice_mode": "MULTIPLE",
          "warning_name_list": [],
          "images": []
        },
        {
          "success_count": 0,
          "warning_count": 0,
          "identifier": "dd147d7e-2a8c-4f8e-80cf-fc3c75fce90f",
          "group_item_name": "机舱线速及插头_图片",
          "show_report_index": false,
          "report_index": 9999,
          "show_report_ok_name": false,
          "report_ok_name": "",
          "show_report_error_name": false,
          "report_error_name": "",
          "choice_mode": "DEFAULT",
          "warning_name_list": [],
          "images": []
        },
        {
          "success_count": 1,
          "warning_count": 0,
          "identifier": "a3eb5578-2056-49e5-8abc-511aab645f97",
          "group_item_name": "保险丝盒",
          "show_report_index": false,
          "report_index": 9999,
          "show_report_ok_name": false,
          "report_ok_name": "",
          "show_report_error_name": false,
          "report_error_name": "",
          "choice_mode": "MULTIPLE",
          "warning_name_list": [],
          "images": []
        },
        {
          "success_count": 0,
          "warning_count": 0,
          "identifier": "6b38006a-ada4-408c-8062-29df1e923cfa",
          "group_item_name": "保险丝盒_图片",
          "show_report_index": false,
          "report_index": 9999,
          "show_report_ok_name": false,
          "report_ok_name": "",
          "show_report_error_name": false,
          "report_error_name": "",
          "choice_mode": "DEFAULT",
          "warning_name_list": [],
          "images": []
        },
        {
          "success_count": 1,
          "warning_count": 0,
          "identifier": "254a7719-4afd-4c29-b34f-a6210b4a5e27",
          "group_item_name": "转向柱",
          "show_report_index": false,
          "report_index": 9999,
          "show_report_ok_name": false,
          "report_ok_name": "",
          "show_report_error_name": false,
          "report_error_name": "",
          "choice_mode": "MULTIPLE",
          "warning_name_list": [],
          "images": []
        },
        {
          "success_count": 0,
          "warning_count": 0,
          "identifier": "ec29b4bd-84fc-47e4-a4f8-746f931f9799",
          "group_item_name": "转向柱_图片",
          "show_report_index": false,
          "report_index": 9999,
          "show_report_ok_name": false,
          "report_ok_name": "",
          "show_report_error_name": false,
          "report_error_name": "",
          "choice_mode": "DEFAULT",
          "warning_name_list": [],
          "images": []
        },
        {
          "success_count": 1,
          "warning_count": 0,
          "identifier": "55863bab-bfca-4368-bfb9-edb17b69c18f",
          "group_item_name": "座椅导轨",
          "show_report_index": false,
          "report_index": 9999,
          "show_report_ok_name": false,
          "report_ok_name": "",
          "show_report_error_name": false,
          "report_error_name": "",
          "choice_mode": "MULTIPLE",
          "warning_name_list": [],
          "images": []
        },
        {
          "success_count": 0,
          "warning_count": 0,
          "identifier": "64de3ad0-51fe-4ec2-b43a-5e8853f2e86e",
          "group_item_name": "座椅导轨_图片",
          "show_report_index": false,
          "report_index": 9999,
          "show_report_ok_name": false,
          "report_ok_name": "",
          "show_report_error_name": false,
          "report_error_name": "",
          "choice_mode": "DEFAULT",
          "warning_name_list": [],
          "images": []
        },
        {
          "success_count": 1,
          "warning_count": 0,
          "identifier": "96779908-956c-40bc-a05b-eca64cc56bfc",
          "group_item_name": "车身线速及插头",
          "show_report_index": false,
          "report_index": 9999,
          "show_report_ok_name": false,
          "report_ok_name": "",
          "show_report_error_name": false,
          "report_error_name": "",
          "choice_mode": "MULTIPLE",
          "warning_name_list": [],
          "images": []
        },
        {
          "success_count": 0,
          "warning_count": 0,
          "identifier": "33ed5b4a-64df-47df-9690-31a7ecceb817",
          "group_item_name": "车身线速及插头_图片",
          "show_report_index": false,
          "report_index": 9999,
          "show_report_ok_name": false,
          "report_ok_name": "",
          "show_report_error_name": false,
          "report_error_name": "",
          "choice_mode": "DEFAULT",
          "warning_name_list": [],
          "images": []
        },
        {
          "success_count": 1,
          "warning_count": 0,
          "identifier": "1a43145a-3c42-49f9-a2b6-59765149e96a",
          "group_item_name": "座椅底部",
          "show_report_index": false,
          "report_index": 9999,
          "show_report_ok_name": false,
          "report_ok_name": "",
          "show_report_error_name": false,
          "report_error_name": "",
          "choice_mode": "MULTIPLE",
          "warning_name_list": [],
          "images": []
        },
        {
          "success_count": 0,
          "warning_count": 0,
          "identifier": "d05950d1-0bc1-473a-bee0-bb328c00e188",
          "group_item_name": "座椅底部_图片",
          "show_report_index": false,
          "report_index": 9999,
          "show_report_ok_name": false,
          "report_ok_name": "",
          "show_report_error_name": false,
          "report_error_name": "",
          "choice_mode": "DEFAULT",
          "warning_name_list": [],
          "images": []
        },
        {
          "success_count": 1,
          "warning_count": 0,
          "identifier": "f2de3c3e-dae4-45b2-bf1a-f47768e2375b",
          "group_item_name": "座椅表面",
          "show_report_index": false,
          "report_index": 9999,
          "show_report_ok_name": false,
          "report_ok_name": "",
          "show_report_error_name": false,
          "report_error_name": "",
          "choice_mode": "MULTIPLE",
          "warning_name_list": [],
          "images": []
        },
        {
          "success_count": 0,
          "warning_count": 0,
          "identifier": "2719fe72-ebb8-46e0-9516-9a91e7f9321d",
          "group_item_name": "座椅表面_图片",
          "show_report_index": false,
          "report_index": 9999,
          "show_report_ok_name": false,
          "report_ok_name": "",
          "show_report_error_name": false,
          "report_error_name": "",
          "choice_mode": "DEFAULT",
          "warning_name_list": [],
          "images": []
        },
        {
          "success_count": 1,
          "warning_count": 0,
          "identifier": "fe7d5aee-956b-46cd-abee-a58b94d69cda",
          "group_item_name": "地胶",
          "show_report_index": false,
          "report_index": 9999,
          "show_report_ok_name": false,
          "report_ok_name": "",
          "show_report_error_name": false,
          "report_error_name": "",
          "choice_mode": "MULTIPLE",
          "warning_name_list": [],
          "images": []
        },
        {
          "success_count": 0,
          "warning_count": 0,
          "identifier": "3e3ccb5f-57da-40d0-ac1e-4a043f78c296",
          "group_item_name": "地胶_图片",
          "show_report_index": false,
          "report_index": 9999,
          "show_report_ok_name": false,
          "report_ok_name": "",
          "show_report_error_name": false,
          "report_error_name": "",
          "choice_mode": "DEFAULT",
          "warning_name_list": [],
          "images": [
            "https://chezhibao.ltd/media/Resource/Image/images/tmp2n362n4r.png",
            "https://chezhibao.ltd/media/Resource/Image/images/tmptwfxirvb.png"
          ]
        },
        {
          "success_count": 1,
          "warning_count": 0,
          "identifier": "00b6bf5c-3c2c-417d-aae5-5d8d03ca44ba",
          "group_item_name": "点烟器底座",
          "show_report_index": false,
          "report_index": 9999,
          "show_report_ok_name": false,
          "report_ok_name": "",
          "show_report_error_name": false,
          "report_error_name": "",
          "choice_mode": "MULTIPLE",
          "warning_name_list": [],
          "images": []
        },
        {
          "success_count": 0,
          "warning_count": 0,
          "identifier": "0799dd0f-499e-4099-b306-f7125b93da7a",
          "group_item_name": "点烟器底座_图片",
          "show_report_index": false,
          "report_index": 9999,
          "show_report_ok_name": false,
          "report_ok_name": "",
          "show_report_error_name": false,
          "report_error_name": "",
          "choice_mode": "DEFAULT",
          "warning_name_list": [],
          "images": []
        },
        {
          "success_count": 1,
          "warning_count": 0,
          "identifier": "fc5a3816-e482-45d9-9321-369a573f3af6",
          "group_item_name": "门内饰板内部",
          "show_report_index": false,
          "report_index": 9999,
          "show_report_ok_name": false,
          "report_ok_name": "",
          "show_report_error_name": false,
          "report_error_name": "",
          "choice_mode": "MULTIPLE",
          "warning_name_list": [],
          "images": []
        },
        {
          "success_count": 0,
          "warning_count": 0,
          "identifier": "fb12c7d1-bd84-4240-a381-eb07c46d139f",
          "group_item_name": "门内饰板内部_图片",
          "show_report_index": false,
          "report_index": 9999,
          "show_report_ok_name": false,
          "report_ok_name": "",
          "show_report_error_name": false,
          "report_error_name": "",
          "choice_mode": "DEFAULT",
          "warning_name_list": [],
          "images": []
        },
        {
          "success_count": 1,
          "warning_count": 0,
          "identifier": "476db12b-9915-4cdd-a8a9-532d761a3a5e",
          "group_item_name": "顶棚",
          "show_report_index": false,
          "report_index": 9999,
          "show_report_ok_name": false,
          "report_ok_name": "",
          "show_report_error_name": false,
          "report_error_name": "",
          "choice_mode": "MULTIPLE",
          "warning_name_list": [],
          "images": []
        },
        {
          "success_count": 0,
          "warning_count": 0,
          "identifier": "91b379ea-b416-4c52-99f8-c43d7cc430c7",
          "group_item_name": "顶棚_图片",
          "show_report_index": false,
          "report_index": 9999,
          "show_report_ok_name": false,
          "report_ok_name": "",
          "show_report_error_name": false,
          "report_error_name": "",
          "choice_mode": "DEFAULT",
          "warning_name_list": [],
          "images": []
        },
        {
          "success_count": 1,
          "warning_count": 0,
          "identifier": "9f660d78-e434-4b6a-a118-b3bf2de7b6c9",
          "group_item_name": "安全带卡扣",
          "show_report_index": false,
          "report_index": 9999,
          "show_report_ok_name": false,
          "report_ok_name": "",
          "show_report_error_name": false,
          "report_error_name": "",
          "choice_mode": "MULTIPLE",
          "warning_name_list": [],
          "images": []
        },
        {
          "success_count": 0,
          "warning_count": 0,
          "identifier": "3cc80782-87cf-4417-b5be-c3f18b2c9a9c",
          "group_item_name": "安全带卡扣_图片",
          "show_report_index": false,
          "report_index": 9999,
          "show_report_ok_name": false,
          "report_ok_name": "",
          "show_report_error_name": false,
          "report_error_name": "",
          "choice_mode": "DEFAULT",
          "warning_name_list": [],
          "images": []
        },
        {
          "success_count": 1,
          "warning_count": 0,
          "identifier": "1f765eaa-9662-4d9d-97b3-aa08bb173f8a",
          "group_item_name": "安全带",
          "show_report_index": false,
          "report_index": 9999,
          "show_report_ok_name": false,
          "report_ok_name": "",
          "show_report_error_name": false,
          "report_error_name": "",
          "choice_mode": "MULTIPLE",
          "warning_name_list": [],
          "images": []
        },
        {
          "success_count": 0,
          "warning_count": 0,
          "identifier": "87ba2fe3-b1e8-4703-9924-ac1c4edadec7",
          "group_item_name": "安全带_图片",
          "show_report_index": false,
          "report_index": 9999,
          "show_report_ok_name": false,
          "report_ok_name": "",
          "show_report_error_name": false,
          "report_error_name": "",
          "choice_mode": "DEFAULT",
          "warning_name_list": [],
          "images": []
        },
        {
          "success_count": 1,
          "warning_count": 0,
          "identifier": "c0041400-5ac3-4a39-8bcc-7929f969242f",
          "group_item_name": "仪表台骨架",
          "show_report_index": false,
          "report_index": 9999,
          "show_report_ok_name": false,
          "report_ok_name": "",
          "show_report_error_name": false,
          "report_error_name": "",
          "choice_mode": "MULTIPLE",
          "warning_name_list": [],
          "images": []
        },
        {
          "success_count": 0,
          "warning_count": 0,
          "identifier": "affe03f9-f3d7-4f5b-aa41-723f4d497a2c",
          "group_item_name": "仪表台骨架_图片",
          "show_report_index": false,
          "report_index": 9999,
          "show_report_ok_name": false,
          "report_ok_name": "",
          "show_report_error_name": false,
          "report_error_name": "",
          "choice_mode": "DEFAULT",
          "warning_name_list": [],
          "images": []
        },
        {
          "success_count": 1,
          "warning_count": 0,
          "identifier": "f52cd0ca-e035-440c-af71-5f1a47c74bf1",
          "group_item_name": "车底线速及插头",
          "show_report_index": false,
          "report_index": 9999,
          "show_report_ok_name": false,
          "report_ok_name": "",
          "show_report_error_name": false,
          "report_error_name": "",
          "choice_mode": "MULTIPLE",
          "warning_name_list": [],
          "images": []
        },
        {
          "success_count": 0,
          "warning_count": 0,
          "identifier": "f78f6995-65ae-4c9c-9b24-5413f00ffbfb",
          "group_item_name": "车底线速及插头_图片",
          "show_report_index": false,
          "report_index": 9999,
          "show_report_ok_name": false,
          "report_ok_name": "",
          "show_report_error_name": false,
          "report_error_name": "",
          "choice_mode": "DEFAULT",
          "warning_name_list": [],
          "images": []
        },
        {
          "success_count": 1,
          "warning_count": 0,
          "identifier": "b9b52665-064b-4007-80cf-1e29f6bb103c",
          "group_item_name": "后备箱舱",
          "show_report_index": false,
          "report_index": 9999,
          "show_report_ok_name": false,
          "report_ok_name": "",
          "show_report_error_name": false,
          "report_error_name": "",
          "choice_mode": "MULTIPLE",
          "warning_name_list": [],
          "images": []
        },
        {
          "success_count": 0,
          "warning_count": 0,
          "identifier": "52e9d796-ef04-404d-a296-28cea00a98ea",
          "group_item_name": "后备箱舱_图片",
          "show_report_index": false,
          "report_index": 9999,
          "show_report_ok_name": false,
          "report_ok_name": "",
          "show_report_error_name": false,
          "report_error_name": "",
          "choice_mode": "DEFAULT",
          "warning_name_list": [],
          "images": []
        },
        {
          "success_count": 1,
          "warning_count": 0,
          "identifier": "3f5cc915-6799-4517-8ebd-7388c21dcbc7",
          "group_item_name": "后备箱线速及插头",
          "show_report_index": false,
          "report_index": 9999,
          "show_report_ok_name": false,
          "report_ok_name": "",
          "show_report_error_name": false,
          "report_error_name": "",
          "choice_mode": "MULTIPLE",
          "warning_name_list": [],
          "images": []
        },
        {
          "success_count": 0,
          "warning_count": 0,
          "identifier": "83e62ad2-cb5e-46ab-868a-7d943c36ed22",
          "group_item_name": "后备箱线速及插头_图片",
          "show_report_index": false,
          "report_index": 9999,
          "show_report_ok_name": false,
          "report_ok_name": "",
          "show_report_error_name": false,
          "report_error_name": "",
          "choice_mode": "DEFAULT",
          "warning_name_list": [],
          "images": []
        },
        {
          "success_count": 1,
          "warning_count": 0,
          "identifier": "9c4a2f40-1a33-4fc1-a12d-f97e89e8e36d",
          "group_item_name": "后备箱附件",
          "show_report_index": false,
          "report_index": 9999,
          "show_report_ok_name": false,
          "report_ok_name": "",
          "show_report_error_name": false,
          "report_error_name": "",
          "choice_mode": "MULTIPLE",
          "warning_name_list": [],
          "images": []
        },
        {
          "success_count": 0,
          "warning_count": 0,
          "identifier": "c2b8a23f-cff1-447b-bccd-d605cbf652e4",
          "group_item_name": "后备箱附件_图片",
          "show_report_index": false,
          "report_index": 9999,
          "show_report_ok_name": false,
          "report_ok_name": "",
          "show_report_error_name": false,
          "report_error_name": "",
          "choice_mode": "DEFAULT",
          "warning_name_list": [],
          "images": []
        }
      ]
    },
    {
      "group_object_id": "7ae76586-175a-466c-a0c7-26e2fc1ce887",
      "group_object_group_id": "a8223db2-98b7-428c-89b4-932d694c6d76",
      "group_name": "火烧检测",
      "group_short_label": "火烧",
      "cover_mode": "Icon",
      "success_count": 12,
      "warning_count": 0,
      "report_label": null,
      "is_active": true,
      "report_config": {
        "identifier": "1566bbc0-e12a-4ab6-a556-0c63c2cbf00f",
        "report_print_index": 9999,
        "show_print_report_icon": true,
        "show_print_report_table": true,
        "show_in_print_report": true,
        "page_break": true,
        "head_page_break": true,
        "test_result_min_height": 100,
        "page_bottom": "0"
      },
      "cover_url": "https://chezhibao.ltd/media/xy_django_app_resource/images/%E7%81%AB%E7%83%A7.png",
      "test_result": null,
      "detected": true,
      "items": [
        {
          "success_count": 1,
          "warning_count": 0,
          "identifier": "ad41d8fa-575f-4b41-b825-82b381a66f06",
          "group_item_name": "发动机机舱",
          "show_report_index": false,
          "report_index": 9999,
          "show_report_ok_name": false,
          "report_ok_name": "",
          "show_report_error_name": false,
          "report_error_name": "",
          "choice_mode": "SINGLE",
          "warning_name_list": [],
          "images": []
        },
        {
          "success_count": 0,
          "warning_count": 0,
          "identifier": "ac295308-174e-4eac-b7d3-73de7d54a0be",
          "group_item_name": "发动机机舱_图片",
          "show_report_index": false,
          "report_index": 9999,
          "show_report_ok_name": false,
          "report_ok_name": "",
          "show_report_error_name": false,
          "report_error_name": "",
          "choice_mode": "DEFAULT",
          "warning_name_list": [],
          "images": []
        },
        {
          "success_count": 1,
          "warning_count": 0,
          "identifier": "38254ec3-afe5-439c-aed0-0f96b8f8176b",
          "group_item_name": "机舱线速",
          "show_report_index": false,
          "report_index": 9999,
          "show_report_ok_name": false,
          "report_ok_name": "",
          "show_report_error_name": false,
          "report_error_name": "",
          "choice_mode": "SINGLE",
          "warning_name_list": [],
          "images": []
        },
        {
          "success_count": 0,
          "warning_count": 0,
          "identifier": "25a7bf24-7e29-4662-aeac-f82abdfc4b6c",
          "group_item_name": "机舱线速_图片",
          "show_report_index": false,
          "report_index": 9999,
          "show_report_ok_name": false,
          "report_ok_name": "",
          "show_report_error_name": false,
          "report_error_name": "",
          "choice_mode": "DEFAULT",
          "warning_name_list": [],
          "images": []
        },
        {
          "success_count": 1,
          "warning_count": 0,
          "identifier": "83efa7db-a026-45d8-8dbd-dd3ac0c816b0",
          "group_item_name": "机舱隔音棉",
          "show_report_index": false,
          "report_index": 9999,
          "show_report_ok_name": false,
          "report_ok_name": "",
          "show_report_error_name": false,
          "report_error_name": "",
          "choice_mode": "SINGLE",
          "warning_name_list": [],
          "images": []
        },
        {
          "success_count": 0,
          "warning_count": 0,
          "identifier": "9939e908-5557-4cd0-abaf-cdfdd95d1e69",
          "group_item_name": "机舱隔音棉_图片",
          "show_report_index": false,
          "report_index": 9999,
          "show_report_ok_name": false,
          "report_ok_name": "",
          "show_report_error_name": false,
          "report_error_name": "",
          "choice_mode": "DEFAULT",
          "warning_name_list": [],
          "images": []
        },
        {
          "success_count": 1,
          "warning_count": 0,
          "identifier": "9e3fa63a-e72c-4ce5-bbcd-9bfbfcb10f27",
          "group_item_name": "防火墙",
          "show_report_index": false,
          "report_index": 9999,
          "show_report_ok_name": false,
          "report_ok_name": "",
          "show_report_error_name": false,
          "report_error_name": "",
          "choice_mode": "SINGLE",
          "warning_name_list": [],
          "images": []
        },
        {
          "success_count": 0,
          "warning_count": 0,
          "identifier": "fced3029-dc4e-42c1-ac06-0a33940b4b86",
          "group_item_name": "防火墙_图片",
          "show_report_index": false,
          "report_index": 9999,
          "show_report_ok_name": false,
          "report_ok_name": "",
          "show_report_error_name": false,
          "report_error_name": "",
          "choice_mode": "DEFAULT",
          "warning_name_list": [],
          "images": []
        },
        {
          "success_count": 1,
          "warning_count": 0,
          "identifier": "c4a91971-196d-41ba-81b5-0e1319090697",
          "group_item_name": "骨架及仪表台",
          "show_report_index": false,
          "report_index": 9999,
          "show_report_ok_name": false,
          "report_ok_name": "",
          "show_report_error_name": false,
          "report_error_name": "",
          "choice_mode": "SINGLE",
          "warning_name_list": [],
          "images": []
        },
        {
          "success_count": 0,
          "warning_count": 0,
          "identifier": "d78fdb90-bf2a-44e3-8100-05aad7a7d92c",
          "group_item_name": "骨架及仪表台_图片",
          "show_report_index": false,
          "report_index": 9999,
          "show_report_ok_name": false,
          "report_ok_name": "",
          "show_report_error_name": false,
          "report_error_name": "",
          "choice_mode": "DEFAULT",
          "warning_name_list": [],
          "images": []
        },
        {
          "success_count": 1,
          "warning_count": 0,
          "identifier": "a29fcdea-535e-483c-b766-aea912f200f7",
          "group_item_name": "座椅",
          "show_report_index": false,
          "report_index": 9999,
          "show_report_ok_name": false,
          "report_ok_name": "",
          "show_report_error_name": false,
          "report_error_name": "",
          "choice_mode": "SINGLE",
          "warning_name_list": [],
          "images": []
        },
        {
          "success_count": 0,
          "warning_count": 0,
          "identifier": "27bd3691-8efa-45ab-a8ab-2b57dc68513e",
          "group_item_name": "座椅_图片",
          "show_report_index": false,
          "report_index": 9999,
          "show_report_ok_name": false,
          "report_ok_name": "",
          "show_report_error_name": false,
          "report_error_name": "",
          "choice_mode": "DEFAULT",
          "warning_name_list": [],
          "images": []
        },
        {
          "success_count": 1,
          "warning_count": 0,
          "identifier": "42805c44-3d4c-410b-abeb-9fed1d2e966c",
          "group_item_name": "顶棚",
          "show_report_index": false,
          "report_index": 9999,
          "show_report_ok_name": false,
          "report_ok_name": "",
          "show_report_error_name": false,
          "report_error_name": "",
          "choice_mode": "SINGLE",
          "warning_name_list": [],
          "images": []
        },
        {
          "success_count": 0,
          "warning_count": 0,
          "identifier": "e3b18b40-2ea5-480f-a383-dd672d82cbcb",
          "group_item_name": "顶棚_图片",
          "show_report_index": false,
          "report_index": 9999,
          "show_report_ok_name": false,
          "report_ok_name": "",
          "show_report_error_name": false,
          "report_error_name": "",
          "choice_mode": "DEFAULT",
          "warning_name_list": [],
          "images": []
        },
        {
          "success_count": 1,
          "warning_count": 0,
          "identifier": "ca1908be-12da-45c9-9db4-76e6828e52b3",
          "group_item_name": "车身线束",
          "show_report_index": false,
          "report_index": 9999,
          "show_report_ok_name": false,
          "report_ok_name": "",
          "show_report_error_name": false,
          "report_error_name": "",
          "choice_mode": "SINGLE",
          "warning_name_list": [],
          "images": []
        },
        {
          "success_count": 0,
          "warning_count": 0,
          "identifier": "e865b327-9ccd-4610-a054-2f8e248cf46e",
          "group_item_name": "车身线束_图片",
          "show_report_index": false,
          "report_index": 9999,
          "show_report_ok_name": false,
          "report_ok_name": "",
          "show_report_error_name": false,
          "report_error_name": "",
          "choice_mode": "DEFAULT",
          "warning_name_list": [],
          "images": []
        },
        {
          "success_count": 1,
          "warning_count": 0,
          "identifier": "d61c108c-5d75-4834-af41-f82cf2d30380",
          "group_item_name": "车身装置",
          "show_report_index": false,
          "report_index": 9999,
          "show_report_ok_name": false,
          "report_ok_name": "",
          "show_report_error_name": false,
          "report_error_name": "",
          "choice_mode": "SINGLE",
          "warning_name_list": [],
          "images": []
        },
        {
          "success_count": 0,
          "warning_count": 0,
          "identifier": "df4664e2-2ec2-4879-90da-da9c97cd451f",
          "group_item_name": "车身装置_图片",
          "show_report_index": false,
          "report_index": 9999,
          "show_report_ok_name": false,
          "report_ok_name": "",
          "show_report_error_name": false,
          "report_error_name": "",
          "choice_mode": "DEFAULT",
          "warning_name_list": [],
          "images": []
        },
        {
          "success_count": 1,
          "warning_count": 0,
          "identifier": "82ba7688-6d1d-4b35-a8d1-afbf9bfb8de3",
          "group_item_name": "全车玻璃",
          "show_report_index": false,
          "report_index": 9999,
          "show_report_ok_name": false,
          "report_ok_name": "",
          "show_report_error_name": false,
          "report_error_name": "",
          "choice_mode": "SINGLE",
          "warning_name_list": [],
          "images": []
        },
        {
          "success_count": 0,
          "warning_count": 0,
          "identifier": "ba910e1c-ba89-465c-8679-c60fd8be21b8",
          "group_item_name": "全车玻璃_图片",
          "show_report_index": false,
          "report_index": 9999,
          "show_report_ok_name": false,
          "report_ok_name": "",
          "show_report_error_name": false,
          "report_error_name": "",
          "choice_mode": "DEFAULT",
          "warning_name_list": [],
          "images": []
        },
        {
          "success_count": 1,
          "warning_count": 0,
          "identifier": "592e5912-2aac-4538-a838-db2c711e284d",
          "group_item_name": "后备箱整体",
          "show_report_index": false,
          "report_index": 9999,
          "show_report_ok_name": false,
          "report_ok_name": "",
          "show_report_error_name": false,
          "report_error_name": "",
          "choice_mode": "SINGLE",
          "warning_name_list": [],
          "images": []
        },
        {
          "success_count": 0,
          "warning_count": 0,
          "identifier": "e0f01431-60cb-48a4-83ae-1837c51def88",
          "group_item_name": "后备箱整体_图片",
          "show_report_index": false,
          "report_index": 9999,
          "show_report_ok_name": false,
          "report_ok_name": "",
          "show_report_error_name": false,
          "report_error_name": "",
          "choice_mode": "DEFAULT",
          "warning_name_list": [],
          "images": []
        },
        {
          "success_count": 1,
          "warning_count": 0,
          "identifier": "1b2d4873-62ee-4c38-bf64-d26198f7b58f",
          "group_item_name": "地毯",
          "show_report_index": false,
          "report_index": 9999,
          "show_report_ok_name": false,
          "report_ok_name": "正常",
          "show_report_error_name": false,
          "report_error_name": "异常",
          "choice_mode": "SINGLE",
          "warning_name_list": [],
          "images": []
        }
      ]
    }
  ]
}

